
import { supabase } from "@/integrations/supabase/client";
import { WidgetDefinition } from "@/components/admin/dashboard/widget-types";
import { mapWidgetEntity } from "./widgetUtils";

// Fetch all widget definitions
export const fetchWidgetDefinitions = async (): Promise<WidgetDefinition[]> => {
  try {
    console.log("Fetching all widget definitions from the database");
    const { data, error } = await supabase.rpc('get_widget_definitions');
    
    if (error) {
      console.error('Error fetching widget definitions:', error);
      throw error;
    }
    
    console.log(`Fetched all widget definitions (${data.length}):`, 
      data.map((w: any) => ({ id: w.id, title: w.title, isActive: w.is_active })));
    
    return data.map(mapWidgetEntity);
  } catch (error) {
    console.error('Error fetching widget definitions:', error);
    return [];
  }
};

// Fetch widget definitions for a specific dashboard type
export const fetchWidgetDefinitionsForDashboard = async (dashboardType: 'admin' | 'user'): Promise<WidgetDefinition[]> => {
  try {
    console.log(`Fetching widget definitions for dashboard type: ${dashboardType}`);
    
    const { data, error } = await supabase
      .rpc('get_widget_definitions', { widget_dashboard_type: dashboardType });
    
    if (error) {
      console.error(`Error fetching widget definitions for ${dashboardType}:`, error);
      throw error;
    }
    
    // Check if financial-result widget exists in the data
    if (dashboardType === 'user') {
      const hasFinancialResult = data.some((w: any) => w.id === 'financial-result');
      if (!hasFinancialResult) {
        console.warn("Financial Result widget not found in database, this might be a problem");
      } else {
        console.log("Financial Result widget found in database");
      }
    }
    
    console.log(`Fetched ${data.length} widget definitions for dashboard type ${dashboardType}:`, 
      data.map((w: any) => ({ id: w.id, title: w.title, isActive: w.is_active })));
    
    return data.map(mapWidgetEntity);
  } catch (error) {
    console.error(`Error fetching ${dashboardType} widget definitions:`, error);
    return [];
  }
};
